// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var EyeClose = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M14.5 5c.25 0 .5.224.5.5 0 .907-.527 1.749-1.341 2.452l1.195 1.194a.5.5 0 0 1-.707.707l-1.301-1.301a9.6 9.6 0 0 1-2.685 1.15l.787 1.574a.5.5 0 0 1-.895.447l-.907-1.812c-.391.058-.776.088-1.146.088s-.755-.03-1.146-.088l-.907 1.812a.5.5 0 0 1-.895-.447l.787-1.574a9.7 9.7 0 0 1-2.685-1.15L1.853 9.853a.5.5 0 0 1-.707-.707l1.195-1.194C1.526 7.248 1 6.407 1 5.5a.5.5 0 0 1 1 0C2 7.126 5.172 9 8 9s6-1.874 6-3.5c0-.25.25-.5.5-.5"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(EyeClose);
export default ForwardRef;
